import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ModalDialogContext from "../../../../Context/ModalDialog/ModalDialogContext";
import { recordTypes } from "../../../../API/config";
import { searchAuditRecords } from "../../../../API/Audit";
import { NoAccessScreen } from "../../../../Component";
import AuditTable from "./Components/AuditTable";
import Search from "./Components/Search";
import styles from "./styles";

const useStyles = makeStyles(styles);

const AuditInfo = (props) => {
  const { hasPermission } = props;

  const classes = useStyles();
  const [auditRecords, setAuditRecords] = useState([]);
  const [searchCriteria, setSearchCriteria] = useState({});
  const [loading, setLoading] = useState(false);
  const [fetchRecords, setFetchRecords] = useState(false);
  const [hasAuditPermission, setAuditHasPermission] = useState();
  const [pageNo, setPageNo] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [totalItems, setTotalItems] = useState(0);

  const { showErrorMessage } = useContext(ModalDialogContext);

  useEffect(() => {
    const evalPermissions = async () => {
      const hasAuditPermission = await hasPermission(
        recordTypes.auditRecord.name,
        recordTypes.auditRecord.actions.view.name);
      setAuditHasPermission(hasAuditPermission);
    };

    const getAuditRecords = async () => {
      try {
        setLoading(true);
        const result = await searchAuditRecords(searchCriteria);
        const { records = [], count } = (result || { records: [], count: 0 }).data;
        setAuditRecords(records);
        setTotalItems(count);
        setLoading(false);
        setFetchRecords(false);
      } catch (error) {
        setLoading(false);
        setFetchRecords(false);
        showErrorMessage({ error });
      }
    }
    evalPermissions();
    if (fetchRecords) {
      getAuditRecords();
    }
  }, [fetchRecords]);

  useEffect(() => {
    setSearchCriteria({ maxRecords: 30, pageNumber: 1, rowsPerPage: rowsPerPage });
    setFetchRecords(true);
  }, []);

  if (!loading && !hasAuditPermission) {
    return <NoAccessScreen />;
  }

  const handleSearch = (sc) => {
    setPageNo(1);
    setSearchCriteria({ ...sc, pageNumber: 1, rowsPerPage: rowsPerPage });
    setFetchRecords(true);
  };

  const handlePageChange = (pgNo) => {
    setPageNo(pgNo);
    setSearchCriteria({
      ...searchCriteria,
      pageNumber: pgNo,
    });
    setFetchRecords(true);
  }

  const handleRowSizeChange = (rSize) => {
    setRowsPerPage(rSize);
    setSearchCriteria({
      ...searchCriteria,
      rowsPerPage: rSize,
    });
    setFetchRecords(true);
  }

  return (
    <div className={classes.container}>
      <Search
        handleSearch={handleSearch}
      />
      <AuditTable
        records={auditRecords}
        loading={loading}
        handlePageSizeChange={handleRowSizeChange}
        rowsPerPage={rowsPerPage}
        pageNumber={pageNo}
        handlePageChange={handlePageChange}
        totalItemsCount={totalItems} />
    </div>
  );
};

export default AuditInfo;
